import Swal from "sweetalert2";

const escapeHtml = (unsafe) =>
    String(unsafe ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

/** پیام خوانا را از پاسخ بک‌اند می‌سازد و {date}/{time} را با مقدار واقعی جایگزین می‌کند */
export function formatAttemptJoinErrorMessage(res) {
    let a = res?.message;
    if (!a) return "امکان ورود به آزمون در حال حاضر وجود ندارد.";
    a = a.split("{").join("").split("}").join("");
    if (a.includes("date")) a = a.replace("date", res?.date ?? "");
    if (a.includes("time")) a = a.replace("time", res?.time ?? "");
    return a;
}

const NOT_ACTIVE_TITLE = "این آزمون در حال حاضر غیرفعال است";
const NOT_ACTIVE_DETAIL = "برای فعال‌سازی یا اطلاع از زمان برگزاری، لطفاً با مجموعهٔ برگزارکنندهٔ آزمون هماهنگ بفرمایید.";

const TIME_EXPIRED_TITLE = "زمان شرکت در این آزمون به پایان رسیده است";
const TIME_EXPIRED_DETAIL = "زمان مجاز برای ورود به این آزمون به پایان رسیده است. در صورت نیاز، لطفاً با مجموعهٔ برگزارکنندهٔ آزمون هماهنگ بفرمایید.";

const TIME_NOT_REACHED_TITLE = "هنوز زمان شروع آزمون فرا نرسیده است";

const NOT_FOUND_TITLE = "آزمون یافت نشد";
const NOT_FOUND_DETAIL = "آزمونی با این شناسه پیدا نشد. لطفاً صحت لینک را بررسی کنید.";

const ALREADY_ATTEMPTED_TITLE = "شما قبلاً در این آزمون شرکت کرده‌اید";
const ALREADY_ATTEMPTED_DETAIL =
    "بر اساس قوانین این آزمون، هر کاربر فقط می‌تواند یک بار شرکت کند. تلاش شما در این آزمون قبلاً ثبت و به پایان رسیده است؛ بنابراین امکان ورود مجدد وجود ندارد.";
const ALREADY_ATTEMPTED_HINT =
    "برای مشاهدهٔ نتیجه یا کارنامه (در صورت فعال بودن نمایش)، به کارنامهٔ خود مراجعه کنید. اگر فکر می‌کنید این پیام اشتباه است، لطفاً با برگزارکنندهٔ آزمون هماهنگ کنید.";

/**
 * نمایش خطای آگاه از وضعیت برای پاسخ attempt_join_quiz بک‌اند
 * @returns true اگر پیام تخصصی نمایش داده شد، false اگر باید روی نمایش پیش‌فرض fallback کنید
 */
export function showAttemptJoinErrorSwal(res, options = {}) {
    const status = res?.status;
    const detailFromBackend = formatAttemptJoinErrorMessage(res);
    const safeDetail = escapeHtml(detailFromBackend);

    if (status === "attempt-finished") {
        Swal.fire({
            rtl: true,
            icon: "info",
            iconColor: "#0ea5e9",
            title: "زمان آزمون به پایان رسیده است",
            html: `
                <div style="text-align:right;">
                    <p style="margin:0 0 14px;font-size:15px;line-height:1.85;color:#334155;">
                        زمان پاسخگویی شما در این آزمون به پایان رسیده و تلاش شما ثبت شده است.
                    </p>
                    <p style="margin:0;font-size:13px;line-height:1.65;color:#64748b;padding-top:10px;border-top:1px solid #e2e8f0;">
                        ${safeDetail}
                    </p>
                </div>
            `,
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "#64748b",
            customClass: { popup: "exam-join-dialog-popup" },
        });
        return true;
    }

    if (status === "not-active") {
        Swal.fire({
            rtl: true,
            icon: "warning",
            iconColor: "#d97706",
            title: NOT_ACTIVE_TITLE,
            html: `
                <div style="text-align:right;">
                    <p style="margin:0 0 14px;font-size:15px;line-height:1.85;color:#334155;">
                        ${escapeHtml(NOT_ACTIVE_DETAIL)}
                    </p>
                </div>
            `,
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "#64748b",
            customClass: { popup: "exam-join-dialog-popup" },
        });
        return true;
    }

    if (status === "start-time-expired" || status === "date-expired") {
        Swal.fire({
            rtl: true,
            icon: "warning",
            iconColor: "#d97706",
            title: TIME_EXPIRED_TITLE,
            html: `
                <div style="text-align:right;">
                    <p style="margin:0 0 14px;font-size:15px;line-height:1.85;color:#334155;">
                        ${escapeHtml(TIME_EXPIRED_DETAIL)}
                    </p>
                    <p style="margin:0;font-size:13px;line-height:1.65;color:#64748b;padding-top:10px;border-top:1px solid #e2e8f0;">
                        ${safeDetail}
                    </p>
                </div>
            `,
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "#64748b",
            customClass: { popup: "exam-join-dialog-popup" },
        });
        return true;
    }

    if (status === "start-time-not-reached") {
        const dateLabel = escapeHtml(String(res?.date ?? "").trim());
        const timeLabel = escapeHtml(String(res?.time ?? "").trim());
        const scheduleBlock =
            dateLabel || timeLabel
                ? `<div style="margin:0 0 14px;display:flex;flex-direction:column;gap:10px;">
                        ${
                            dateLabel
                                ? `<div style="display:flex;justify-content:space-between;align-items:center;gap:12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;padding:12px 14px;">
                                        <span style="font-size:13px;color:#64748b;">تاریخ شروع</span>
                                        <strong style="font-size:15px;color:#0f172a;direction:ltr;">${dateLabel}</strong>
                                   </div>`
                                : ""
                        }
                        ${
                            timeLabel
                                ? `<div style="display:flex;justify-content:space-between;align-items:center;gap:12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;padding:12px 14px;">
                                        <span style="font-size:13px;color:#64748b;">ساعت شروع</span>
                                        <strong style="font-size:15px;color:#0f172a;direction:ltr;">${timeLabel}</strong>
                                   </div>`
                                : ""
                        }
                   </div>`
                : "";
        Swal.fire({
            rtl: true,
            icon: "info",
            iconColor: "#0ea5e9",
            title: TIME_NOT_REACHED_TITLE,
            html: `
                <div style="text-align:right;">
                    <p style="margin:0 0 14px;font-size:15px;line-height:1.85;color:#334155;">
                        هنوز زمان مجاز برای ورود به این آزمون فرا نرسیده است. لطفاً در تاریخ و ساعت مشخص‌شده دوباره تلاش کنید.
                    </p>
                    ${scheduleBlock}
                    <p style="margin:0;font-size:13px;line-height:1.65;color:#64748b;padding-top:10px;border-top:1px solid #e2e8f0;">
                        ${safeDetail}
                    </p>
                </div>
            `,
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "#64748b",
            customClass: { popup: "exam-join-dialog-popup" },
        });
        return true;
    }

    if (status === "not-found") {
        Swal.fire({
            rtl: true,
            icon: "error",
            iconColor: "#dc2626",
            title: NOT_FOUND_TITLE,
            html: `<p style="margin:0;font-size:15px;line-height:1.85;color:#334155;text-align:right;">${escapeHtml(NOT_FOUND_DETAIL)}</p>`,
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "#64748b",
            customClass: { popup: "exam-join-dialog-popup" },
        });
        return true;
    }

    const looksLikeAlreadyAttempted =
        status === "maximum-attempt-reached" ||
        detailFromBackend.includes("محدودیت حساب کاربری") ||
        detailFromBackend.includes("قبلا") ||
        detailFromBackend.includes("قبلاً");

    if (looksLikeAlreadyAttempted) {
        Swal.fire({
            rtl: true,
            icon: "info",
            iconColor: "#0ea5e9",
            title: ALREADY_ATTEMPTED_TITLE,
            html: `
                <div style="text-align:right;">
                    <p style="margin:0 0 14px;font-size:15px;line-height:1.85;color:#334155;">
                        ${escapeHtml(ALREADY_ATTEMPTED_DETAIL)}
                    </p>
                    <p style="margin:0 0 14px;font-size:14px;line-height:1.75;color:#0c4a6e;background:linear-gradient(135deg,#eff6ff 0%,#dbeafe 100%);border-radius:12px;padding:14px 16px;border:1px solid #bfdbfe;">
                        ${escapeHtml(ALREADY_ATTEMPTED_HINT)}
                    </p>
                    <p style="margin:0;font-size:13px;line-height:1.65;color:#64748b;padding-top:10px;border-top:1px solid #e2e8f0;">
                        ${safeDetail}
                    </p>
                </div>
            `,
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "#64748b",
            customClass: { popup: "exam-join-dialog-popup" },
        });
        return true;
    }

    if (options.handledStatuses && options.handledStatuses.includes(status)) {
        return false;
    }

    Swal.fire({
        rtl: true,
        icon: "error",
        iconColor: "#dc2626",
        title: "امکان شروع آزمون نیست",
        html: `<p style="margin:0;font-size:15px;line-height:1.75;color:#334155;text-align:right;">${safeDetail}</p>`,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "#64748b",
        customClass: { popup: "exam-join-dialog-popup" },
    });
    return true;
}
